/* eslint-disable */
import { Box, TextField, IconButton, Typography, Paper, Button } from '@mui/material'
import {
  Delete as DeleteIcon,
  Upload as UploadIcon,
  Description as FileIcon,
  PictureAsPdf as PdfIcon,
  Download as DownloadIcon,
} from '@mui/icons-material'
import { useEffect, useRef, useState } from 'react'

interface FileInfo {
  id: string
  filename: string
  url?: string
}

export default function FileUploadAndList({ fileList }: any) {
  const [files, setFiles] = useState<FileInfo[]>(fileList || [])

  useEffect(() => {
    if (fileList) {
      setFiles(fileList)
    }
  }, [fileList])

  const [impact, setImpact] = useState('')
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    const droppedFiles = Array.from(e.dataTransfer.files)
    handleFiles(droppedFiles)
  }

  const handleFiles = (newFiles: File[]) => {
    const newFileInfos = newFiles.map((file) => ({
      id: Math.random().toString(36),
      filename: file.name,
      type: file.type.split('/')[1],
    }))
    setFiles((prev) => [...prev, ...newFileInfos])
  }

  const getAttachementNameAndType = (attachment: any) => {
    const name = attachment?.filename || ''
    const type = name ? name.split('.').pop() : ''
    return { name, type }
  }

  const handleDownload = async (file: FileInfo) => {
    try {
      if (file.url) {
        console.log('show file url', file.url)
        const link = document.createElement('a')
        link.href = file.url
        link.download = file.filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        // const response = await fetch(file.url!)
        // const blob = await response.blob()
        // const url = window.URL.createObjectURL(blob)
        // const link = document.createElement('a')
        // link.href = url
        // link.download = file.name
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        // window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.error('Download failed:', error)
    }
  }

  const handleDelete = (fileId: string) => {
    setFiles((prev) => prev.filter((f) => f.id !== fileId))
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          height: '90px',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          overflow: 'auto',
          p: 2,
        }}
      >
        {files.map((file) => (
          <Box
            key={file.id}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              py: 1,
              borderBottom: '1px solid #f0f0f0',
            }}
          >
            {getAttachementNameAndType(file).type === 'pdf' ? (
              <PdfIcon color='error' />
            ) : (
              <FileIcon color='primary' />
            )}
            <Typography sx={{ flex: 1 }}>{file.filename}</Typography>
            <Box sx={{ display: 'flex', gap: '5px' }}>
              <IconButton size='small' onClick={() => handleDelete(file.id)}>
                <DeleteIcon fontSize='small' />
              </IconButton>
              <IconButton size='small' onClick={() => handleDownload(file)}>
                <DownloadIcon fontSize='small' />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
      <Paper
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        sx={{
          border: '2px dashed #9e9e9e',
          borderRadius: '4px',
          p: 2,
          textAlign: 'center',
          backgroundColor: '#fafafa',
          cursor: 'pointer',
        }}
        onClick={() => fileInputRef.current?.click()}
      >
        <input
          type='file'
          ref={fileInputRef}
          style={{ display: 'none' }}
          multiple
          onChange={(e) => {
            if (e.target.files) {
              handleFiles(Array.from(e.target.files))
            }
          }}
        />
        <UploadIcon sx={{ fontSize: 40, color: '#9e9e9e' }} />
        <Typography>Drag and drop files here or click to select files</Typography>
      </Paper>
    </Box>
  )
}
